import React, {Component} from 'react';
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarAlt, faDownload, faTruck} from '@fortawesome/free-solid-svg-icons'
import API from "../../services/API";
// import { DatePicker } from "react-persian-datepicker";
import moment from "moment-jalaali";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";
import Loading from "../Common/Loading";
/*const styles = {
    calendarContainer: 'calendarContainer',
    dayPickerContainer: 'dayPickerContainer',
    monthsList: 'monthsList',
    daysOfWeek: 'daysOfWeek',
    dayWrapper: 'dayWrapper',
    selected: 'selected',
    heading: 'heading',
    prev: 'prev',
    next: 'next',
    title: 'title'
}*/
class RequestsSmallCargo extends Component {
    state = {
        requests : [],
        trackingCode : '',
        statuses : [],
        status: 0,
        date_from :moment().subtract(7,'days'),
        date_to: moment(),
        isLoaded:false,
        companyName : ''
    }
    onSearchTrackingCode = (event) => {
        this.setState({
            trackingCode:event.target.value
        })
        if(event.target.value.length > 3) {
            const request = {
                proccess_for : 'Expert',
                tracking_code : event.target.value,
                small_cargo : 1
            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    this.setState({requests})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                proccess_for : 'Expert',
                small_cargo : 1

            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    this.setState({requests})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
    }
    onSearchCompany = (event) => {
        this.setState({
            companyName:event.target.value
        })
        if(event.target.value.length > 3) {
            const request = {
                proccess_for : 'Expert',
                company_name : event.target.value,
                status_id: this.state.status,
                small_cargo : 1
            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    this.setState({requests})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                proccess_for : 'Expert',
                small_cargo : 1

            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    this.setState({requests})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
    }
    onStateChange = (event) => {

        this.setState({status : event.target.value});
        const request = {
            proccess_for : 'Expert',
            status_id: event.target.value,
            company_name :  this.state.companyName,
            small_cargo : 1

        }
        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                this.setState({requests})

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });

    }
    render() {
        return (
            <React.Fragment >
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast  />
                <Actionbar noBack={1} title=' لیست درخواست ها'/>
                <section className="container my-5 py-4 ">
                    {/* <div className="row filter-request-dialog max-w-lg fixed-bottom rtl">
                        <div className="col-12 title">
                            فیلتر درخواست ها
                        </div>
                        <div className="col-4 super-small text-dark text-center ">
                            وضعیت درخواست
                        </div>
                        <div className="col-8">
                            <div className="form-group ">
                                <select className="form-select w-100 super-small  bg-light" id="statuses" name="statuses"
                                        aria-label=" label select example"
                                        value={this.state.status}
                                        onChange={(event) => {this.setState({status : parseInt(event.target.value)})}}>
                                    <option value={0}>
                                       فرقی نمی کند
                                    </option>
                                    {this.state.statuses.map(st => {
                                        return (
                                            <option value={st.id} key={st.id} style={{color:st.color}}>
                                                {st.title}
                                            </option>
                                        )
                                    })}
                                </select>

                            </div>

                        </div>

                        <div className="col-4 super-small text-dark text-center ">
                           تاریخ بارگیری از
                        </div>
                        <div className="col-md-3 form-group pick-date super-small text-left">
                                        <span>
                                            از
                                        </span>
                            <DatePicker
                                calendarStyles={styles}
                                inputFormat="jYYYY/jM/jD"
                                className="form-control pdate-picker w-50 d-inline"
                                value={this.state.date_from}
                                onChange={(value) => this.onDateChange(value , 'date_from')}
                            />
                        </div>

                        <div className="col-4 super-small text-dark text-center ">
                            وضعیت درخواست
                        </div>

                    </div>*/}
                    <div className="row mb-2 rtl">
                        <div className="col-6">
                            <div className="form-group ">
                                <select className="form-select w-100 super-small py-2 bg-light" id="statuses" name="statuses"
                                        aria-label=" label select example"
                                        value={this.state.status}
                                        onChange={this.onStateChange} >
                                    <option value={0}>
                                        فیلتر بر اساس وضعیت
                                    </option>
                                    {this.state.statuses.map(st => {
                                        return (
                                            <option value={st.id} key={st.id} style={{color:st.color}}>
                                                {st.title}
                                            </option>
                                        )
                                    })}
                                </select>

                            </div>

                        </div>
                        <div className="col-6">
                            <div className="form-floating super-small-2">
                                <input type="number" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو کد رهگیری"
                                       onChange={this.onSearchTrackingCode}
                                       value={this.state.trackingCode}
                                />
                                <label htmlFor="floatingInput">جستجو کد رهگیری</label>
                            </div>
                        </div>
                        <div className="col-12 mt-2">
                            <div className="form-floating super-small-2">
                                <input type="text" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو  شرکت"
                                       onChange={this.onSearchCompany}
                                       value={this.state.companyName}
                                />
                                <label htmlFor="floatingInput">جستجو بر اساس نام شرکت</label>
                            </div>
                        </div>
                    </div>
                    <div className="row px-2">
                        {
                            this.state.requests.map (request => {
                                return (
                                    <div className="col-12 rtl mb-2 request-row pb-2 bg-light "
                                         onClick={() => this.props.history.push(`/request/${request.id}`)}
                                         key={request.id}
                                    >
                                        <div className="row  mx-2 py-2">
                                            <div className="col-6 badge badge-info badge-pill bg-secondary float-right ">{request.company.title}
                                                &nbsp;
                                                :
                                                &nbsp;
                                                {request.tracking_code}</div>
                                            <div className="col-6 text-left super-small-2" style={{color:request.status.color}}>{request.status.title}</div>
                                            {/* <div className="col-12 mt-2 super-small">
                                                از:
                                                &nbsp;
                                                {request.loading_addresses[0].title}
                                                &nbsp;
                                                {request.loading_addresses[0].address.substring(0, 25)} ...
                                            </div>*/}
                                            <div className="col-12 mt-2 super-small">
                                                <FontAwesomeIcon icon={faDownload} />
                                                &nbsp;
                                                {request.unloading_addresses[0].title}
                                                &nbsp;
                                                {request.unloading_addresses[0].address.substring(0, 25)} ...
                                            </div>
                                            <div className="col-12 mt-3 super-small-2">
                                                <div className='float-left text-dark'>

                                                    {request.loading_date}
                                                    &nbsp;
                                                    <FontAwesomeIcon icon={faCalendarAlt} />

                                                </div>
                                                <div>
                                                    <FontAwesomeIcon icon={faTruck} className='text-secondary' />
                                                    &nbsp;
                                                    {request.car_type.parent}
                                                    &nbsp;
                                                    -
                                                    &nbsp;
                                                    {request.car_type.title}
                                                    &nbsp;&nbsp;
                                                    {request.driver.last_name ?

                                                        <strong>
                                                            (
                                                            {request.driver.last_name}
                                                            )
                                                        </strong>
                                                        : ''
                                                    }




                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )} )
                        }
                    </div>
                </section>

                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {
            proccess_for : 'Expert',
            small_cargo : 1
        }
        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                this.setState({requests})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)
            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });

        API.getStatuses()
            .then((response) => {
                const statuses = response.results.statuses;
                this.setState({statuses})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
}

export default RequestsSmallCargo;